const ENDPOINT = new Map();
ENDPOINT.set('get', '/course/calendar/get');
ENDPOINT.set('leave', '/course/calendar/abandon');
export default ENDPOINT
